import React from 'react';
import { InstantSearch, Configure } from 'react-instantsearch-dom';

import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { PagesResults } from '../../commons/helpers';

const SearchPagesContent = ({
  facetFilters,
  indexName,
  page,
  query,
  searchState,
  searchStateQuery,
  toggleIsSearchOpen,
  updateSearchPage,
}) => (
  <div className="w-full">
    <InstantSearch
      searchClient={searchClient}
      searchState={searchState}
      indexName={indexName}
    >
      <Configure
        query={searchStateQuery}
        hitsPerPage={9}
        facetFilters={facetFilters}
        numericFilters={['is_active=1', 'show_in_search=1', 'fk_store_id=1']}
      />

      <PagesResults
        toggleSearchOpen={toggleIsSearchOpen}
        onLoadMore={updateSearchPage}
        query={query}
        currentPage={page}
        variant="advanced-search"
      />
    </InstantSearch>
  </div>
);

export default SearchPagesContent;
